<template>
  <div class="c-group">
    <filters
      v-if="mediaVal === 6"
      agent
      promoted
      :states="states"
      :placeholder="`请输入${open}名称`"
      :inventory="inventory"
      :billing="billing"
      :invenType="invenType"
      @on-change="filterData"
      @on-search="searchFilterData"
    ></filters>
    <filters
      v-else
      :states="states"
      :placeholder="`请输入${open}名称`"
      agent
      game
      pricing
      rule
      :inventory="inventory"
      :billing="billing"
      :invenType="invenType"
      @on-change="filterData"
      @on-search="searchFilterData"
    ></filters>
    <div class="c-control-btn">
      <div>
        <ElButton type="primary" @click="openNewEntry">新建{{ open }}</ElButton>
        <ElDropdown @command="handleDropDownClick">
          <ElButton style="margin-left: 5px">
            批量操作
            <Icon type="ios-arrow-down"></Icon>
          </ElButton>
          <ElDropdownMenu slot="dropdown">
            <ElDropdownItem :command="1">启用</ElDropdownItem>
            <ElDropdownItem :command="0">暂停</ElDropdownItem>
            <ElDropdownItem :command="-1">删除</ElDropdownItem>
          </ElDropdownMenu>
        </ElDropdown>
        <ElButton v-if="mediaVal === 16" style="margin-left: 5px" @click="downData">数据导出</ElButton>
        <Tag
          v-if="id && mediaVal === 6"
          style="margin-left: 12px; padding: 5px 15px 6px; height: 32px"
          color="primary"
          closable
          @on-close="clearExtraFilter"
        >
          {{ `1个${id > 0 ? '推广组' : '账号'}中的计划` }}
        </Tag>
      </div>
      <div class="control-right-btns">
        <div class="c-account-balance">
          <span>账户余额：</span>
          <Icon v-if="balancing" type="ios-loading" size="18" class="c-account-load" color="#2b85e4"></Icon>
          <span v-else>{{ balance | toThousands }} 元</span>
        </div>
        <ElButton @click="modalColumn = true">自定义列</ElButton>
      </div>
    </div>
    <!-- 表格列表 -->
    <div class="c-table-list" :aaa="tableHeight">
      <Viewport v-model="tableHeight">
        <plan-table
          ref="planTable"
          :value="spining"
          :data="planList"
          :columns="tableCol"
          :media="mediaVal"
          :height="tableHeight"
          @on-sort="sortTable"
          @on-refresh="getData"
          @on-copy="copyClick"
          @header-dragend="headerDragend"
        ></plan-table>
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>
    <!-- 新建对话框 -->
    <copy-plan-modal v-model="modalOpen" :data="copyPlanData" :title="`复制${open}`" :media="mediaVal" @on-cancel="modalOpen = false" />
    <custom-column v-model="modalColumn" :data="columns" @on-select="selectColumn" />
  </div>
</template>
<script>
import mixin from './mixin'
import { mapActions } from 'vuex'
import { getPlanList } from '@/api/convert.model'
import { HOST_API } from '@/api/config'
import Filters from '@/components/converter/filter.vue'
import CopyPlanModal from '@/components/converter/copyplan-modal.vue'
import CustomColumn from '@/components/converter/custom-column.vue'
import PlanTable from '@/components/converter/table/table-plan.vue'

import { PLAN_TOUTIAO, PLAN_UC, PLAN_TENCENT, PLAN_BAIDU, PLAN_KUAISHOU } from '../data/tableTitle'
import { isEmpty, isArray } from '@/common/js/utils'

export default {
  name: 'PlanList',
  mixins: [mixin],
  components: { Filters, CustomColumn, CopyPlanModal, PlanTable },
  computed: {
    mediaVal() {
      return parseInt(this.$route.params.id)
    },
    open() {
      let title
      if (this.mediaVal === 10) title = '投放计划'
      else if (this.mediaVal === 6) title = '推广计划'
      else if (this.mediaVal === 16) title = '计划'
      else if (this.mediaVal === 45) title = '推广单元'
      else if (this.mediaVal === 32) title = '计划组'
      return title
    },
    // 存local用户自定义列
    custom() {
      let custom
      if (this.mediaVal === 10) custom = 'plan'
      else if (this.mediaVal === 6) custom = 'ucunit'
      else if (this.mediaVal === 16) custom = 'teunit'
      else if (this.mediaVal === 45) custom = 'bdunit'
      else if (this.mediaVal === 32) custom = 'ksunit'
      return custom
    },
    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    },
    inventory() {
      return [10].includes(this.mediaVal)
    },
    billing() {
      let pricing
      if (this.mediaVal === 10) pricing = ['OCPC', 'CPC', 'OCPM', 'CPM']
      else if (this.mediaVal === 6) pricing = ['CPC', 'CPM']
      else if (this.mediaVal === 16) pricing = ['OCPA', 'CPC', 'CPM']
      else if (this.mediaVal === 45) pricing = ['OCPC', 'OCPM', 'CPC', 'CPM']
      else if (this.mediaVal === 32) pricing = ['OCPM']
      return pricing
    },
    invenType() {
      let invenType
      if (this.mediaVal === 10) {
        invenType = [
          {
            key: 'INVENTORY_FEED',
            value: '头条系'
          },
          {
            key: 'INVENTORY_VIDEO_FEED',
            value: '西瓜信息流'
          },
          // {
          //   key: 'INVENTORY_HOTSOON_FEED',
          //   value: '火山信息流'
          // },
          {
            key: 'INVENTORY_AWEME_FEED',
            value: '抖音信息流'
          },
          {
            key: 'INVENTORY_UNION_SLOT',
            value: '穿山甲'
          },
          {
            key: 'UNION_BOUTIQUE_GAME',
            value: '穿山甲精选休闲游戏'
          }
        ]
      }
      return invenType
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => `${met.key}${met.width ? `|${met.width}` : ''}`)
        this.setCustomStorage(`${this.custom}CustomColumn`, show)
        this.$nextTick(() => {
          this.$refs.planTable && this.$refs.planTable.doLayout()
        })
      },
      deep: true
    },
    id: {
      handler(nVal, oVal) {
        if (nVal !== oVal) {
          this.getData()
        }
      },
      deep: true
    },
    $route(to, from) {
      if (this.$router.currentRoute.query.adAccountId) {
        this.adAccountId = this.$router.currentRoute.query.adAccountId
        this.isValidPlan = this.$router.currentRoute.query.isValidPlan
        this.id = this.$router.currentRoute.query.id
      }
    }
  },
  methods: {
    ...mapActions('Convert', ['handleAsync']),
    // 自定义列 全选
    selectColumnAll(params) {
      const { type, show } = params
      const data = this.columns.filter((ret) => ret.type === type)
      data.forEach((ret) => {
        this.$set(ret, 'show', show)
      })
    },
    clearExtraFilter() {
      this.adAccountId = ''
      this.isValidPlan = ''
      this.id = ''
    },
    getData(filter) {
      let params = {
        mediaId: this.mediaVal,
        page_id: this.pageIndex,
        page_size: this.pageSize,
        sort: this.sort,
        order: this.order
      }

      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)

      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))

      // 临时参数拼接
      if (this.id > 0) params.adGroupId = this.id
      if (!params.adAccountId) params.adAccountId = this.adAccountId
      // 是否筛选投放中计划
      if (this.isValidPlan) params.isValidPlan = this.isValidPlan

      // 请求数据
      this.spining = true
      getPlanList(
        Object.assign(params, {
          selectJson: JSON.stringify(params)
        })
      ).then((data) => {
        this.spining = false
        if (data && data.list && data.page_info) {
          // eslint-disable-next-line
          const { total_number } = data.page_info
          const fmt_tofix = (num) => parseFloat(num.toFixed(2))
          this.planList = data.list.map((ret) => {
            ret.optStatus = ret.optStatus === 1
            ret.paperAmount = fmt_tofix(ret.paperAmount)
            ret.amount = fmt_tofix(ret.amount)
            ret.perClickPrice = fmt_tofix(ret.perClickPrice)
            ret.thousandsOfDisplayCosts = fmt_tofix(ret.thousandsOfDisplayCosts)
            ret.convertCost = fmt_tofix(ret.convertCost)
            ret.activeCost = fmt_tofix(ret.activeCost)
            ret.registerCost = fmt_tofix(ret.registerCost)
            ret.budgetFlag = parseInt(ret.budget) > 0 ? 1 : 0
            ret.bid = ret.bid === 0 ? '-' : ret.bid
            ret.bid2 = ret.deepConversionType === '付费ROI' ? '-' : typeof ret.bid2 === 'number' ? ret.bid2 : '-'
            ret.roiRatioValue = ret.roiRatio
            // 下面这行代码把roiRatio重置了，不知道要干什么，另外保存roiRatio到roiRatioValue,百度需要回显_20230315
            ret.roiRatio = ret.deepConversionType === '付费ROI' || ret.ocpxActionType === '付费ROI' ? ret.roiRatio : '-'
            ret.day_budget_schedule = isArray(ret.day_budget_schedule) ? ret.day_budget_schedule : '不限'
            return ret
          })
          // eslint-disable-next-line
          this.total = total_number ? total_number : 0
          this.$nextTick(() => {
            this.$refs.planTable && this.$refs.planTable.doLayout()
          })
          this.mainVal && this.handleAsync()
        }
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.setLocalPage(size)
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    handleDropDownClick(type) {
      if ([1, 0, -1].includes(type)) {
        this.$refs.planTable.changeBetch(type)
      }
    },
    // 计划复制
    copyClick(row) {
      this.modalOpen = true
      this.copyPlanData = row
    },
    downData() {
      let url = `${HOST_API}/api/ptom/thirdPlan/down`
      url += `?sessionid=${this.$store.state.token}&mediaId=${this.mediaVal}`
      url += `&queryBeginTime=${this.params.queryBeginTime}&queryEndTime=${this.params.queryEndTime}`
      this.params.adAccountId && (url += `&adAccountId=${this.params.adAccountId}`)
      this.params.opId && (url += `&opId=${this.params.opId}`)
      this.params.gameId && (url += `&gameId=${this.params.gameId}`)
      this.params.bidMode && (url += `&bidMode=${this.params.bidMode}`)
      !isEmpty(this.params.isAutoRule) && (url += `&isAutoRule=${this.params.isAutoRule}`)
      !isEmpty(this.params.status) && (url += `&status=${this.params.status}`)
      this.params.keyWord && (url += `&keyWord=${this.params.keyWord}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      window.open(url)
    }
  },
  data() {
    return {
      tableHeight: 330,
      id: this.$router.currentRoute.query.id,
      adAccountId: this.$router.currentRoute.query.adAccountId,
      isValidPlan: this.$router.currentRoute.query.isValidPlan, // 是否筛选投放中计划
      modalOpen: false, // 新建对话框
      copyPlanData: {}, // 复制计划数据
      modalColumn: false, // 自定义列
      spining: null, // 表格数据加载
      planList: [], // 投放计划列表
      columns: [],
      states: [
        {
          value: -1,
          label: '不限'
        },
        {
          value: 0,
          label: '未知'
        },
        {
          value: 1,
          label: '投放中'
        },
        {
          value: 2,
          label: '暂停'
        },
        {
          value: 3,
          label: '审核中'
        },
        {
          value: 4,
          label: '审核不通过'
        },
        {
          value: 5,
          label: '账户余额不足'
        },
        {
          value: 6,
          label: '计划预算不足'
        },
        {
          value: 7,
          label: '未到投放时间'
        },
        {
          value: 8,
          label: '计划组暂停'
        },
        {
          value: 9,
          label: '准备中'
        },
        {
          value: 10,
          label: '冻结'
        },
        {
          value: 11,
          label: '投放结束'
        },
        {
          value: 12,
          label: '计划组预算不足'
        },
        {
          value: 13,
          label: '账户日预算不足'
        }
      ]
    }
  },
  created() {
    let columns
    this.$store.commit('Convert/setMedia', String(this.mediaVal))
    const shows = this.getCustomStorage(`${this.custom}CustomColumn`)
    // 表格列数据
    if (this.mediaVal === 10) columns = PLAN_TOUTIAO
    else if (this.mediaVal === 6) columns = PLAN_UC
    else if (this.mediaVal === 16) columns = PLAN_TENCENT
    else if (this.mediaVal === 45) columns = PLAN_BAIDU
    else if (this.mediaVal === 32) columns = PLAN_KUAISHOU
    // 同步本地存储自定义列
    if (shows.length) {
      this.columns = columns
        .sort((a, b) => {
          const idxA = shows.findIndex((ret) => ret.includes(a.key))
          const idxB = shows.findIndex((ret) => ret.includes(b.key))
          const sortA = idxA < 0 ? idxA : shows.length - idxA
          const sortB = idxB < 0 ? idxB : shows.length - idxB
          return sortB - sortA
        })
        .map((ret) => {
          const shifRet = shows.filter((met) => met && met.includes('|') && met.includes(ret.key)).shift()
          ret.show = !shows
            .filter((met) => met)
            .map((met) => (met.includes('|') ? met.split('|').shift() : met))
            .includes(ret.key)
          shifRet && (ret.width = parseInt(Number(shifRet.split('|').pop() || '')))
          return ret
        })
    } else {
      this.columns = [...columns]
    }
  }
}
</script>
<style lang="scss" scoped>
.c-group {
  .c-control-btn {
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    .control-right-btns {
      display: flex;
    }

    .ivu-btn {
      margin-left: 0 !important;
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }

  .c-account-balance {
    line-height: 32px;
    font-size: 13px;
    margin-right: 8px;
    color: #ff0000;
  }

  .c-account-load {
    animation: ani-demo-spin 1s linear infinite;
  }
}
</style>
